import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';

import {
  LOAD_AUDIENSE,
  UPDATE_AUDIENSE,
  HARD_DELETE_AUDIENSE,
} from './constants';

import {
  loadAudienceDetailSuccess,
  loadAudienceDetailError,
  // change
  changeAudienceSuccess,
  changeAudienceError,
  // delete
  hardDeleteAudienceSuccess,
  hardDeleteAudienceError,
} from './actions';

import history, { parseQuery, encodeQueryData } from 'utils/history';


export function* loadSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { detailID } = action;

    // we get the campaigns linked to the communication
    const itemData = yield requestWrapper(
      'GET',
      `audiences/${detailID}`,
      '',
      currentUser.token,
    );

    if (!detailID && !itemData) {
      yield put(loadAudienceDetailSuccess(false));
    } else {
      yield put(loadAudienceDetailSuccess(itemData));
    }
  } catch (error) {
    yield put(loadAudienceDetailError(error));
  }
}

export function* changeSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const searchParams = parseQuery(window.location.search) || null;
    
    const { itemDetail } = action;
    


    let updateElement = false,
      isNew = !itemDetail.hasOwnProperty('_id');

    if (isNew) {
      updateElement = yield requestWrapper(
        'POST',
        'audiences/new/',
        itemDetail,
        currentUser.token,
      );
    } else {
      updateElement = yield requestWrapper(
        'PATCH',
        'audiences/',
        itemDetail,
        currentUser.token,
      );
    }

    if (!updateElement) {
      yield put(changeAudienceSuccess(false));
    } else if (
      updateElement.hasOwnProperty('data') ||
      updateElement.hasOwnProperty('code')
    ) {
      yield put(changeAudienceSuccess(updateElement));
      if (updateElement?.data) {
        let currentData = searchParams;
        const serachStr = encodeQueryData(currentData);
        history.push({
          pathname: `/audiences/${updateElement?.data?._id}`,
          search: `?${serachStr}`,
          state: {
            isNew: false,
            preview: false,
          }
        });
      }
    } else {
      // if new we update the url, item props will be updated
      if (isNew && updateElement?._id) {
        let currentData = searchParams;
        const serachStr = encodeQueryData(currentData);
        history.push({
          pathname: `/audiences/` + updateElement._id,
          search: `?${serachStr}`,
          state: {
            isNew: true,
            preview: false,
          }
        });
      }
      yield put(changeAudienceSuccess(updateElement));
    }
  } catch (error) {
    yield put(changeAudienceError(error));
  }
}


export function* hardDeleteSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { hardDeleteId } = action;

    const hardDelte = yield requestWrapper(
      'PATCH',
      `audiences/delete`,
      { objects: [hardDeleteId] },
      currentUser.token,
    );

    if (!hardDelte) {
      yield put(hardDeleteAudienceSuccess(false));
    } else {
      yield put(hardDeleteAudienceSuccess(hardDelte, hardDeleteId));
    }
  } catch (err) {
    yield put(hardDeleteAudienceError(err));
  }
}



export default function* audienceDetailSaga() {
  yield takeLatest(LOAD_AUDIENSE, loadSaga);
  yield takeLatest(UPDATE_AUDIENSE, changeSaga);
  yield takeLatest(HARD_DELETE_AUDIENSE, hardDeleteSaga);
}
